import * as yup from "yup";

export const loginSchema = yup.object().shape({
    email: yup.string().trim(true).email("wrong-email").required("required"),
    password: yup.string().trim(true).required("required"),
});
